import en from 'element-plus/es/locale/lang/en'

import { defineAdminLocale } from '../locale-definition'
import { adminMessages } from '../messages'

export default defineAdminLocale({
  code: 'en-US',
  name: 'English',
  order: 30,
  elementPlusLocale: en,
  messages: adminMessages.en
})
